import React, {Component} from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";
import {deepCopyObject, getNaceCodes, showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import DefaultModal from "../invoice/DefaultModal";
import Alert from "react-s-alert";
import {isValidRequiredFieldData} from "../../common/componentValidation";
import Select from "../../local_node_modules/react-select";
import {showBaro} from "../../helper/permission"
import {VirtualHost} from "../../constants";
import Datetime from "react-datetime";
import * as moment from "moment";

class CustomerRequiredFieldModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error:{},
            filteredTaxOffices:[],
            requiredField:{
                city:"",
                taxOffice:"",
                mersisNo:"",
                ticaretSicilNo:"",
                phone:"",
                streetName:"",
                commerceChamber:"",
                naceCode:[]
            },
            cities:[],
            taxOffices:[],
            disableSaveButton: false
        };
        this.onChange = this.onChange.bind(this);
        this.saveClicked = this.saveClicked.bind(this);
        this.showBaroFields = this.showBaroFields.bind(this);
    }

    componentWillMount() {
        let self = this;
        this.setState({requiredField:this.props.requiredField});
        request({
            url: `/checkinformation/getList`,
            method: 'post'
        }).then(response => {
            let data = response.data;
            let filteredTaxOffices = data.taxOffices.filter(to => to.city === self.props.requiredField.city);
            this.setState({cities: data.cities, taxOffices:data.taxOffices,filteredTaxOffices});
        }).catch(error => {
            showAxiosError(error);
        });
    }

    onChange(name, value) {
        let requiredField = deepCopyObject(this.state.requiredField);
        requiredField[name] = value;
        this.setState({requiredField});
        if(name==="city"){
            let taxOffices = this.state.taxOffices;
            let filteredTaxOffices = taxOffices.filter(to => to.city === value);
            requiredField["taxOffice"] = "";
            this.setState({filteredTaxOffices, requiredField});
        }
    }

    saveClicked() {
        let self = this;
        self.setState({saveLoading:true});
        let result = isValidRequiredFieldData(this.state.requiredField);
        let error = result.error;
        let valid = result.valid;
        if (valid) {
            let params = {
                url: `/checkinformation/saveInformation`,
                method: 'post',
                data: self.state.requiredField
            };
            request(params)
            .then(response => {
                Alert.success(response.data, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 1000
                });
                self.setState({disableSaveButton: false});
                self.props.toggle();
            }).catch(error => {
                self.setState({disableSaveButton: false});
                showAxiosError(error);
            });
        }else{
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 8000
            });
            this.setState({error: error});
        }
    }

    showBaroFields(){
        return (showBaro() && !(["esmm","musavir","turcef"].includes(VirtualHost.conf.resourcePrefix)));
    }

    prepareCustomValue(e) {
        return e.customValue
    }

    showNaceOption(e) {
        this.setState({
            selectedNaceOption: e.label,
            naceModal: true
        })
    }

    onChangeNaceCodes(data) {
        let requiredField = deepCopyObject(this.state.requiredField);
        let selectedItemList = [];
        data.map(d =>
            selectedItemList.push({
                id: d.value,
                code:d.customValue,
                description:d.description
            })
        );
        requiredField.naceCode = selectedItemList;
        this.setState({requiredField});
    }

    prepareStatusSelectData(naceCodeList=[]){
        let selectData = [];
        naceCodeList.map((item) => {
            selectData.push({
                value: item.id,
                customValue: item.code,
                description: item.description,
                label:item.code + ' , ' + item.description
            })
        });
        return selectData;
    }

    render() {
        return (
            <DefaultModal
                disabled={this.state.disableSaveButton}
                isOpen={this.props.show}
                title="Aşağıdaki bilgilerinizi kontrol edip eksik/hatalı olan bilgilerinizi doldurunuz."
                size="lg"
                confirmBtnText="Kaydet"
                cancelBtnText=""
                onConfirm={this.saveClicked}>
                <Col sm="12">
                    <Row>
                        <Col sm={12}>
                            <p className="text-danger"><span>* </span>Ticaret sicil müdürlüğüne kaydınız varsa Mersis No bilgisinin girilmesi zorunludur.</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="city">Vergi Dairesinin Bulunduğu İl: *</Label>
                                <Col sm={12}>
                                    <Select
                                        clearable={false}
                                        className="select-control"
                                        value={this.state.requiredField.city}
                                        placeholder="Seçiniz..."
                                        onChange={(e) => this.onChange("city",e.value)}
                                        options={this.state.cities.map(city => ({
                                            value: city.cityName,
                                            label: city.cityName
                                        }))}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="taxOffice">Vergi Dairesi: *</Label>
                                <Col sm={12}>
                                    <Select
                                        clearable={false}
                                        className="select-control"
                                        name="taxOffice"
                                        value={this.state.requiredField.taxOffice}
                                        placeholder="Seçiniz..."
                                        onChange={(e) => this.onChange("taxOffice", e.value)}
                                        options={this.state.filteredTaxOffices.map(to => ({
                                            value: to.vdName,
                                            label: to.vdName
                                        }))}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="email">e-Posta: </Label>
                                <Col sm={12}>
                                    <Input type="text" name="email" value={this.state.requiredField.email}
                                           onChange={(e) => this.onChange("email", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="streetName">Cadde/Sokak/Mahalle: *</Label>
                                <Col sm={12}>
                                    <Input type="text" name="streetName" value={this.state.requiredField.streetName}
                                           onChange={(e) => this.onChange("streetName", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="buildingName">Bina Adı: </Label>
                                <Col sm={12}>
                                    <Input type="text" name="buildingName" value={this.state.requiredField.buildingName}
                                           onChange={(e) => this.onChange("buildingName", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="buildingNo">Bina Numarası: </Label>
                                <Col sm={12}>
                                    <Input type="text" name="buildingNo" value={this.state.requiredField.buildingNo}
                                           onChange={(e) => this.onChange("buildingNo", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="doorNo">Kapı Numarası: </Label>
                                <Col sm={12}>
                                    <Input type="text" name="doorNo" value={this.state.requiredField.doorNo}
                                           onChange={(e) => this.onChange("doorNo", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="postalCode">Posta Kodu: *</Label>
                                <Col sm={12}>
                                    <Input type="text" name="postalCode" value={this.state.requiredField.postalCode}
                                           onChange={(e) => this.onChange("postalCode", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="phone">Telefon Numarası: *</Label>
                                <Col sm={12}>
                                    <Input type="text" name="phone" value={this.state.requiredField.phone}
                                           onChange={(e) => this.onChange("phone", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="fax">Fax: </Label>
                                <Col sm={12}>
                                    <Input type="text" name="fax" value={this.state.requiredField.fax}
                                           onChange={(e) => this.onChange("fax", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        {!this.showBaroFields() &&
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="mersisNo">Mersis No: </Label>
                                <Col sm={12}>
                                    <Input type="text" maxLength={16} name="mersisNo" value={this.state.requiredField.mersisNo}
                                           onChange={(e) => this.onChange("mersisNo", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                        }
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="ticaretSicilNo">{this.showBaroFields() ? "Baro Sicil No":"Ticaret Sicil No"}: </Label>
                                <Col sm={12}>
                                    <Input type="text" name="ticaretSicilNo" value={this.state.requiredField.ticaretSicilNo}
                                           onChange={(e) => this.onChange("ticaretSicilNo", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                        {this.showBaroFields() &&
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="commerceChamber">Kayıtlı Olunan Baro: </Label>
                                <Col sm={12}>
                                    <Input type="text" name="commerceChamber"
                                           value={this.state.requiredField.commerceChamber}
                                           onChange={(e) => this.onChange("commerceChamber", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                        }
                    </Row>


                    <Row>
                        <Col sm={12}>
                            <FormGroup row>
                                <Label sm={10}>Nace Kodu: *</Label>
                                <Col sm={12}>
                                    <Select.Async multi
                                                  value={this.prepareStatusSelectData(this.state.requiredField.naceCode)}
                                                  valueRenderer={(e) => this.prepareCustomValue(e)}
                                                  onValueClick={(e) => this.showNaceOption(e)}
                                                  onChange={(e) => this.onChangeNaceCodes(e)}
                                                  isLoading={true}
                                                  autoload={false}
                                                  cache={false}
                                                  clearable={false}
                                                  arrowRenderer={this.arrowRenderer}
                                                  noResultsText="Kayıt bulunamadı."
                                                  searchPromptText="Arama için en az 1 karakter giriniz."
                                                  placeholder="NACE kodu veya açıklaması ile arama yapabilirsiniz"
                                                  loadingPlaceholder="Yükleniyor..."
                                                  loadOptions={getNaceCodes}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                    </Row>

                    {VirtualHost.conf.resourcePrefix === "togb" &&
                    <Row>
                        {VirtualHost.conf.resourcePrefix === "togb" &&
                        <Col sm={12}>
                            <Label sm={12} style={{display:"flex",justifyContent:"center",fontWeight:"bold", fontSize:"15px"}}>Mesul Müdür Bilgileri </Label>
                        </Col>
                        }
                        {VirtualHost.conf.resourcePrefix === "togb" &&
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="mesulMudurAdSoyad">Ad Soyad: </Label>
                                <Col sm={12}>
                                    <Input type="text" name="mesulMudurAdSoyad"
                                           value={this.state.requiredField.mesulMudurAdSoyad}
                                           onChange={(e) => this.onChange("mesulMudurAdSoyad", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                        }
                        {VirtualHost.conf.resourcePrefix === "togb" &&
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="mesulMudurRuhsatnameTarih">Müessese Ruhsatname Tarihi: </Label>
                                <Col sm={12}>
                                    <Datetime locale="tr"
                                              inputProps={{id: "mesulMudurRuhsatnameTarih",readonly:"readonly"}}
                                              className="datepicker"
                                              input={true}
                                              closeOnSelect={true}
                                              value={moment(this.state.requiredField.mesulMudurRuhsatnameTarih, "YYYY-MM-DD", true).isValid() ? moment(this.state.requiredField.mesulMudurRuhsatnameTarih).format("DD-MM-YYYY") : this.state.requiredField.mesulMudurRuhsatnameTarih}
                                              dateFormat="DD-MM-YYYY"
                                              timeFormat={false}
                                              isValidDate={function (current) {
                                                  return current.isBefore(Datetime.moment());
                                              }}
                                              onChange={(momentObj) => this.onChange("mesulMudurRuhsatnameTarih", (!(typeof momentObj === "string") ? momentObj.format("YYYY-MM-DD") : momentObj))}
                                    />
                                </Col>
                            </FormGroup>
                        </Col>
                        }
                        {VirtualHost.conf.resourcePrefix === "togb" &&
                        <Col sm={6}>
                            <FormGroup row>
                                <Label sm={10} for="mesulMudurBelgeNo">Belge No: </Label>
                                <Col sm={12}>
                                    <Input type="text" name="mesulMudurBelgeNo"
                                           value={this.state.requiredField.mesulMudurBelgeNo}
                                           onChange={(e) => this.onChange("mesulMudurBelgeNo", e.target.value)}/>
                                </Col>
                            </FormGroup>
                        </Col>
                        }
                    </Row>
                    }
                </Col>
            </DefaultModal>
        );
    }
}

export default CustomerRequiredFieldModal;